import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './horizontalTabs.scss';

import { Link } from '@ui-kit';
import { getCustomer } from '@entities';
import { ROLES, SUB_ROLES } from '@entities/user';
import { 
    ADMIN_USER_SETTINGS_URL,
    ADMIN_USER_PASSWORD_URL,
    ADMIN_USER_REFERRAL_URL,
    ADMIN_USER_BRIEFS_URL,
    ADMIN_ADOBE_RATING_URL,
    //ADMIN_PURCHASES_URL,
    //ADMIN_USER_BILLS_URL,
} from '@app/routes';


const HorizontalTabs = () => {
    const location = useLocation();
    const user = useSelector(getCustomer);

    useEffect(()=> {
      const header = document.querySelector('.header');

      header.classList.add('non-border');
      return () =>  header.classList.remove('non-border');
    },[])

    const tabsLinks = [
        {
          url : ADMIN_USER_SETTINGS_URL,
          name: 'My details'
        },
        {
          url : ADMIN_USER_PASSWORD_URL,
          name: 'Password'
        },
        {
            url : ADMIN_USER_REFERRAL_URL,
            name: 'Referral'
        },
        /*{
          url : ADMIN_PURCHASES_URL,
          name: 'My purchases'
        },*/
        /*{
          url : ADMIN_USER_BILLS_URL,
          name: 'My bills'
        },*/
    ];

    if (user?.role === ROLES.ADMIN || user?.subRole === SUB_ROLES.MYTEAMART) {
        tabsLinks.push({
            url : ADMIN_USER_BRIEFS_URL,
            name: 'My briefs'
        });
        tabsLinks.push({
            url : ADMIN_ADOBE_RATING_URL,
            name: 'Adobe rating'
        });
    }

    const isActiveButton = (url) => {
        const path = url.pathname;      
        if (path === location.pathname) {
            return 'active';
        }

        return '';
    }

    return (
        <div className="admin-navigate profile-navigate d-flex df-column jc-sb">
            <div className="d-flex df-column">
                <div className="admin-navigate__tab d-flex df-column">
                    {tabsLinks.map((item, index) => {
                        return (
                            <Link 
                                theme="text"
                                size="md"
                                key={index}
                                className={`tab-link ${isActiveButton(item.url)}`}
                                to={item.url}
                            >
                                {item.name}
                            </Link>
                    )})}
                </div>
            </div>
        </div>
    )
};

export default HorizontalTabs; 